/* === 追加①：-foreveryone 用モーダル生成（1回だけ） ===================== */
function dtwEnsureForeveryoneDialog() {
  let dlg = document.getElementById('dtw-foreveryone-dialog');
  if (dlg) return dlg;

  dlg = document.createElement('dialog');
  dlg.id = 'dtw-foreveryone-dialog';
  dlg.className = 'dtw-foreveryone-dialog';
  dlg.innerHTML = `
  <form method="dialog" class="dtw-foreveryone-dialog__inner">
    <div class="dtw-foreveryone-dialog__header">
      <h2 class="dtw-foreveryone-dialog__title">確認</h2>
      <button value="cancel" class="dtw-foreveryone-dialog__close" aria-label="閉じる">×</button>
    </div>

    <p class="dtw-foreveryone-dialog__text">
      本商品は「一般購入向け（どなたでも購入可）」の商品です。
    </p>

 <p class="dtw-foreveryone-dialog__text">
  同シリーズのオールイン／アソートを購入済みのお客様は、
  「【オールイン／アソート購入者限定】」表記の別商品が用意されている場合があります。
</p>

    <p class="dtw-foreveryone-dialog__note">
      ※「【オールイン／アソート購入者限定】」商品は仕様上、同時注文ができません。
    </p>

    <p class="dtw-foreveryone-dialog__question">
      このまま本商品をカートに追加しますか？
    </p>

    <div class="dtw-foreveryone-dialog__actions">
      <button value="cancel" class="dtw-foreveryone-dialog__btn dtw-foreveryone-dialog__btn--cancel">
        キャンセル
      </button>
      <button value="continue" class="dtw-foreveryone-dialog__btn dtw-foreveryone-dialog__btn--continue">
        続行（承知の上で追加）
      </button>
    </div>

    <p class="dtw-foreveryone-dialog__sub">
      <a href="/pages/guide#limited-product" target="_blank" rel="noopener" class="dtw-foreveryone-dialog__link">
        購入者限定商品とは？
      </a>
    </p>
  </form>
`;


  document.body.appendChild(dlg);
  return dlg;
}

/* === 追加②：商品ページ（/products/）かつ handle末尾 -foreveryone 判定 ===== */
function dtwIsForeveryoneProductPage() {
  // wishlist 等を確実に除外
  const isProductPath = window.location.pathname.startsWith('/products/');
  if (!isProductPath) return false;

  // あなたのテーマは product-info を商品ページで使っているので二重ガード
  // （セクション流用で product-form が他ページに出ても巻き込まれにくくする）
  const hasProductInfo = !!document.querySelector('product-info');
  if (!hasProductInfo) return false;

  const parts = window.location.pathname.split('/products/');
  const handle = (parts[1] || '').split(/[/?#]/)[0];
  return handle.endsWith('-foreveryone');
}

/* ======================================================================== */

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        /* === 追加③：-foreveryone のときだけモーダルで一旦止める ========== */
        if (this.form) {
          // 続行後の1回だけは素通し（無限ループ防止）
          if (this.form.dataset.dtwForeveryoneBypass === '1') {
            delete this.form.dataset.dtwForeveryoneBypass;
          } else {
            if (dtwIsForeveryoneProductPage()) {
              const dlg = dtwEnsureForeveryoneDialog();

              // 既に開いている場合は再表示しない
              if (!dlg.open) dlg.showModal();

              // close を 1 回だけ拾う
              const onClose = () => {
                dlg.removeEventListener('close', onClose);

                if (dlg.returnValue === 'continue') {
                  // 連打対策（続行ボタンを無効化）
                  const continueBtn = dlg.querySelector('button[value="continue"]');
                  if (continueBtn) continueBtn.disabled = true;

                  // 次の1回だけ通す
                  this.form.dataset.dtwForeveryoneBypass = '1';

                  // 既存の submit 経路で再実行（＝既存AJAX→ミニドロワーを維持）
                  if (typeof this.form.requestSubmit === 'function') {
                    this.form.requestSubmit(this.submitButton);
                  } else {
                    this.form.submit();
                  }
                }
                // cancel は何もしない（/cart/add が飛ばない）
              };

              dlg.addEventListener('close', onClose);
              return;
            }
          }
        }
        /* ================================================================== */

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
